"use strict";

import { submitCertificate } from './commons/certificate.js';

import {
    domElementExistByQuery
} from './commons/domCheck.js';

import { validateForm, activeFieldEventsValidator } from './commons/formsValidators.js';
import { searchUrlParam } from './commons/utm.js';
import { endYoutubeVideo } from './commons/youtube.js';


document.addEventListener("DOMContentLoaded", () => {
    const url = document.getElementById('adminUrl').innerHTML;
    const loaderPage = document.getElementById('loader-page');

    if (domElementExistByQuery('#demoInternalInitialLogueado') || domElementExistByQuery('#demoInternalAdvancedLogueado')) {
        loaderPage.classList.add('visible');

        const type = document.querySelector('main').getAttribute('type');
        const startBannerContainer = document.getElementById('startBanner');
        const endBanner = document.getElementById('endBanner');
        const downloadCertificateBtn = document.querySelector('#certificateForm button');
        const menuItems = document.querySelectorAll('.pageVideo__aside__nav .pageVideo__aside__nav__item a');
        const feedbackForm = document.getElementById('feedbackForm');
        const feedbackFormButton = feedbackForm.querySelector('button');

        const maxVideos = 3;
        const prevButton = document.getElementById('prev');
        const nextButton = document.getElementById('next');
        const allFrames = document.querySelectorAll('.youtubeFrame');
        const nextLevelContainer = document.querySelector('.pageVideo__content__next-level');

        var userVideoProgress = 0;
        var currentVideoNumber = 0;
        var endCurrentDemo = false;

        feedbackFormButton.addEventListener('click', (e) => {

            e.preventDefault();
            const formData = new FormData(feedbackForm);
            formData.append('action', 'submitFormFeedback');
            formData.append('type', type);
            formData.append('from_form', 'doppler-demo-feedback');
            formData.append('utm_source', searchUrlParam('utm_source'));
            formData.append('utm_campaign', searchUrlParam('utm_campaign'));
            formData.append('utm_content', searchUrlParam('utm_content'));
            formData.append('utm_term', searchUrlParam('utm_term'));
            formData.append('utm_medium', searchUrlParam('utm_medium'));
            formData.append('origin', searchUrlParam('origin'));

            if (validateForm(feedbackForm)) {
                feedbackFormButton.classList.add('button--loading');
                feedbackFormButton.disabled = true;
                document.querySelector('.feedbackForm').style.opacity = "0.5";
                fetch(url, {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                }).then(resp => {
                    if (!resp.ok) throw new Error('No se pudo enviar el feedback', resp);
                    feedbackForm.reset();
                    feedbackFormButton.classList.remove('button--loading');
                    document.querySelector('.feedbackForm').style.opacity = "1";
                    feedbackFormButton.disabled = false;
                    if (resp.ok) document.querySelector('.success-message').style.display = "block"
                }).catch(error => {
                    throw new Error('No se pudo enviar el feedback', error);
                });
            } else {
                document.querySelector('.feedbackForm__form__item__checkbox input').addEventListener('click', () => { document.querySelector('.feedbackForm__form__item__checkbox').classList.remove("ac--error"); })
                activeFieldEventsValidator();
            }




        });

        menuItems.forEach((menuItem, index) => {
            menuItem.addEventListener('click', () => {
                if (userVideoProgress >= (index + 1)) {
                    endBanner.classList.add('ac-dp--none');
                    currentVideoNumber = (index + 1);
                    setUserFrame(index + 1);
                    setVideoButtons();
                    checkButtonsDisplay();
                }
            });
        });

        downloadCertificateBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const form = new FormData(document.getElementById('certificateForm'));
            form.append('type', type);
            form.append('action', "downloadCerticateDopplerDemo");
            form.append('utm_source', searchUrlParam('utm_source'));
            form.append('utm_campaign', searchUrlParam('utm_campaign'));
            form.append('utm_content', searchUrlParam('utm_content'));
            form.append('utm_term', searchUrlParam('utm_term'));
            form.append('utm_medium', searchUrlParam('utm_medium'));
            form.append('origin', searchUrlParam('origin'));

            fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: form,
            }).then(resp => console.log(resp));
            submitCertificate(form, type);
        });

        startBannerContainer.querySelector('button').addEventListener('click', async () => {
            loaderPage.classList.add('visible');
            const formData = new FormData();
            formData.append('action', 'registerInDopplerDemo');
            formData.append('type', type);
            formData.append('from_form', 'doppler_demo');
            formData.append('utm_source', searchUrlParam('utm_source'));
            formData.append('utm_campaign', searchUrlParam('utm_campaign'));
            formData.append('utm_content', searchUrlParam('utm_content'));
            formData.append('utm_term', searchUrlParam('utm_term'));
            formData.append('utm_medium', searchUrlParam('utm_medium'));
            formData.append('origin', searchUrlParam('origin'));

            await fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            })
                .then(resp => {
                    if (resp.ok) {
                        startBannerContainer.classList.add('ac-dp--none');
                        currentVideoNumber = 1;
                        setUserFrame(currentVideoNumber);
                        setVideoButtons(currentVideoNumber);
                    } else {
                        throw new Error('No se pudo registrar en DopplerDemo');
                    }
                    loaderPage.classList.remove('visible');
                }
                );

        });


        const getLastVideoView = async () => {
            loaderPage.classList.add('visible');
            const formData = new FormData();
            formData.append('action', 'getLastVideoViewedDopplerDemo');
            formData.append('type', type);

            const response = await fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            });
            const lastView = await response.json();
            return lastView;
        };

        getLastVideoView().then(({ isRegister, numberVideo }) => {
            numberVideo = numberVideo + 1;

            if (isRegister) {
                endCurrentDemo = (numberVideo > maxVideos);
                currentVideoNumber = numberVideo;
                if (endCurrentDemo) {
                    userVideoProgress = 3;
                    setVideoButtons();
                    setMenuProperties();
                    if (type === 'inicial') nextLevelContainer.classList.remove('ac-dp--none');
                    endBanner.classList.remove('ac-dp--none');
                } else {
                    userVideoProgress = numberVideo;
                    setUserFrame(currentVideoNumber);
                    setVideoButtons();
                    setMenuProperties();

                }
            } else {
                startBannerContainer.classList.remove('ac-dp--none');
            }
            loaderPage.classList.remove('visible');
        });

        const checkButtonsDisplay = () => {
            prevButton.classList.remove('ac--vh');
            nextButton.classList.remove('ac--vh');
            nextButton.innerHTML = 'SIGUIENTE';
            if (currentVideoNumber === 1) {
                prevButton.classList.add('ac--vh');
            } else if (currentVideoNumber === 3) {
                nextButton.classList.remove('ac--vh');
                nextButton.innerHTML = 'FINALIZAR';
            }
            if (currentVideoNumber > maxVideos) {
                nextButton.classList.add('ac--vh');
            }

        }

        const hiddenAllFrames = () => {
            allFrames.forEach(frame => {
                frame.classList.add('ac-dp--none')
            })
        }

        const setUserFrame = (numberVideo) => {
            hiddenAllFrames();
            document.getElementById(`video${numberVideo}`).classList.remove('ac-dp--none');
        }


        const setMenuProperties = () => {
            const menuItems = document.querySelectorAll('.pageVideo__aside__nav a');
            menuItems.forEach((item, index) => {
                if (index < userVideoProgress) item.classList.add('pageVideo_item--viewed');
            });
        }

        const changeUserFrame = (btn) => {
            endYoutubeVideo(allFrames);
            endCurrentDemo = (currentVideoNumber >= maxVideos);

            if (btn.id === 'next') {
                if (endCurrentDemo) {
                    submitVideo(3);
                    userVideoProgress = 4;
                    currentVideoNumber = 4;
                    hiddenAllFrames();
                    nextButton.classList.add('ac--vh');
                    if (type === 'inicial') nextLevelContainer.classList.remove('ac-dp--none');
                    endBanner.classList.remove('ac-dp--none');
                } else {
                    submitVideo(currentVideoNumber);
                    currentVideoNumber++;
                    userVideoProgress++;
                    setUserFrame(currentVideoNumber);
                }
                endCurrentDemo = (currentVideoNumber >= maxVideos);
            } else {
                endBanner.classList.add('ac-dp--none');
                if (currentVideoNumber > 1) {
                    currentVideoNumber--;
                    setUserFrame(currentVideoNumber);
                }
            }
        }

        const setVideoButtons = () => {
            const btnsContainer = document.querySelector('.dopplerDemoVideo__content__video__btn__container');
            const buttons = btnsContainer.querySelectorAll('button');
            btnsContainer.classList.remove('ac-dp--none');
            checkButtonsDisplay();
            buttons.forEach(btn => {
                if (btn.getAttribute('listener') !== 'true') {
                    btn.setAttribute('listener', 'true');
                    btn.addEventListener('click', () => {
                        changeUserFrame(btn);
                        setMenuProperties();
                        checkButtonsDisplay();
                    });
                }
            });
        }

        const submitVideo = (videoNumber) => {
            const formData = new FormData();
            formData.append('action', 'videoViewedDopplerDemo');
            formData.append('videoNumber', videoNumber);
            formData.append('type', type);

            fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            })
                .then(resp => { if (!resp.ok) throw new Error('Error en submit video', resp) })
                .catch(error => { throw new Error('Error en submit video', error) });
        }

    }

});
